export const apiRemote = {
  available: 1,
  partial: 2,
  full: 3
};

export const getRemoteNameFromApiValue = apiValue => Object.keys(apiRemote).find(key => apiRemote[key] === apiValue);

export default { apiRemote, getRemoteNameFromApiValue };
